<template lang="pug">
section.settings__section
  .settings__container
    .h-vertical-align-container(v-if='modal.show')
      .modal__close(@click='removeOverlay()')
      .modal__overlay(@click='removeOverlay()')
      .modal__wrapper
        .modal__form.modal__form--manageSub
          h1 Manage your subscription
          a.btn.btn--black(:href='updateUrl') Update payment method
          a.btn.btn--white(:href='cancelUrl') Cancel subscription

    .h-vertical-align-container(v-if='modalerror.show')
      .modal__close(@click='removeOverlay()')
      .modal__overlay(n@click='removeOverlay()')
      .modal__wrapper
        .modal__form.modal__form--manageSub.modal__form--manageSubError
          h1 We've encountered an error.
          h2 Please contact Flixel so that we can resolve this for you.
          a(href='mailto:support@flixel.com?subject=Manage%20Subscription%20Error')
            button.btn.btn--purpleLight Contact Support
          p support@flixel.com

    .account__section--messages(v-if='message')
      .message.error(v-if='error')
        p {{ error }}
        a.close(@click='error = false; message = false')
      .message.success(v-if='success')
        p Changes saved successfully.
        a.close(@click='success = false; message = false')

    .settings__flixelPlan
      .settings__flixelPlan--header
        .settings__flixelPlan--title
          h1 {{ subscription.plan_display_name }}
          h2(v-if='!checkPlan("free")') Subscription valid until {{ subscription.expiry_date | date }}
        button.btn.btn--purpleLight(
          v-if='!checkPlan("free")',
          @click='openManageSub()'
          ) Manage Subscription
        get-plan(v-if='checkPlan("free")')

    .flixelPlan__content
      .flixelPlan__content--item(v-if='!checkPlan("agency")')
        p.meter__title Storage
        p.meter__title {{ convertToGb(subscription.storage_usage) }} of {{ convertToGb(subscription.storage_limit) }}
      Meter.flixelPlan__meter(v-if='!checkPlan("agency")', val1='subscription.storage_usage', val2='subscription.storage_limit')
      .warning(v-if='isOverLimit(subscription.storage_usage, subscription.storage_limit)')
        p Storage usage exceeded! Consider upgrading to increase your limit.

      .flixelPlan__content--item(v-if='subscription.plan_includes_hosting')
        p.meter__title Embed Views
        p.meter__title {{ subscription.embed_count | number }} of {{ subscription.embed_count_limit | number }}
      div(v-if='subscription.plan_includes_hosting')
        Meter(:val1='subscription.embed_count', :val2='subscription.embed_count_limit')
      .warning(v-if='isOverLimit(subscription.embed_count, subscription.embed_count_limit)')
        p Embed views exceeded! Consider upgrading to increase your limit.

      .flixelPlan__content-item(v-if='checkPlan("agency")')
        p.meter__title You have unlimited Flixel storage.
        // p.meter__title Embed views of all cinemagraphs is {{ subscription.embed_count | number }}.

    .settingSection__title
      h3 Public Details

    .publicDetails__section
      form(name='updateUser', v-on:submit.prevent='updateUserInvoke(updatedProfile, updatedAccount)')
        .settings__inputs
          .ui-input
            .ui-input--item
              label Photo
            .ui-input--item
              .avatar(
                :style="{ backgroundImage: 'url(' + user.profile.avatar + ')' }"
                v-if='!newAvatar')
                p Update Profile Picture
                .avatar__text
                .hidden_fileupload
                  input(
                    type='file',
                    @change="processAvatar($event)"
                    file-model='newAvatar')
              .avatar(
                :style="{ backgroundImage: 'url(' + newAvatar + ')' }"
                v-if='newAvatar')
                p Update Profile Picture
                .avatar__text
                .hidden_fileupload
                  input(
                    type='file',
                    file-model='newAvatar')

          .ui-input.ui-input--center
            .ui-input--item
              label Name
            .ui-input--item
              input(
                type='text',
                placeholder='Your name',
                v-model='updatedProfile.realname',
                maxlength=50)

          .ui-input.ui-input--center
            .ui-input--item
              label Email
            .ui-input--item
              input(
                type='text',
                placeholder='Your email',
                v-model='updatedAccount.email',
                maxlength= 35,
                required)

          .ui-input.ui-input--center
            .ui-input--item
              label Website
            .ui-input--item
              input(type='text',
                placeholder='Your website',
                v-model='updatedProfile.url',
              )

          .ui-input
            .ui-input--item
              label Bio
            .ui-input--item
              textarea(
                maxlength=140,
                placeholder='Something interesting about yourself ',
                v-model='updatedProfile.description',
                cols="10",
                rows="5",
                charswidth="23"
                )
          .ui-input
            .ui-input--item
              button.btn.btn--purpleLight(
                type='submit',
                class='{ invalid: updateUser.$invalid }'
                ) Save changes

    .settingSection__title
      h3 Consent

    .publicDetails__section
      form(name='updateUser', v-on:submit.prevent='updateUserInvoke(updatedProfile, updatedAccount)')
        .settings__inputs
          .ui-input
            .ui-input--item.marketingConsent--container.ui-input--desktop
              label.checkbox--container
                input(
                  type='checkbox',
                  v-model='updatedProfile.marketing_consent',
                )
                span.checkmark
            .ui-input--item.marketingConsent--container
              label.checkbox--container.ui-input--mobile
                input(
                  type='checkbox',
                  v-model='updatedProfile.marketing_consent',
                )
                span.checkmark
              h4 Marketing Consent
              .subtext
                p Flixel can send me product updates and offers via email

          .ui-input
            .ui-input--item.marketingConsent--container.ui-input--desktop
              label.checkbox--container
                input(
                  type='checkbox',
                  v-model='updatedProfile.tracking_consent',
                )
                span.checkmark
            .ui-input--item.marketingConsent--container
              label.checkbox--container.ui-input--mobile
                input(
                  type='checkbox',
                  v-model='updatedProfile.tracking_consent',
                )
                span.checkmark
              h4 Analytics Consent
              .subtext
                p Help Flixel improve our app by sharing app activity
          .ui-input
            .ui-input--item
              button.btn.btn--purpleLight(
                type='submit',
                class='{ invalid: updateUser.$invalid }'
                ) Save changes

    a(id='changePassword')
    .settingSection__title
      h3 Change Your Password

    .publicDetails__section
      form(name='updatePassword', v-on:submit.prevent='updateUserInvoke(updatedProfile, updatedAccount)')
        .settings__inputs
          .ui-input.ui-input--center
            .ui-input--item
              label New Password
            .ui-input--item
              input(
                type='password',
                name='password',
                v-model='updatedAccount.password',
                placeholder='Your new password',
                required)
          .ui-input.ui-input--center
            .ui-input--item
              label Type it again
            .ui-input--item
              input(
                type='password',
                v-model='password_repeat',
                placeholder='Type it again',
                required)
          .ui-input
            .ui-input--item
              button.btn.btn--purpleLight(
                :class='{invalid: updatedAccount.password !== password_repeat || !updatedAccount.password || updatedAccount.password.length < 6}'
                ) Save changes
</template>

<script>
import { _ } from 'vue-underscore';
import moment from 'moment';
import UtilitiesService from 'services/utilities.es6.js';
import ProfileService from 'services/profile.es6.js';
import AuthService from 'services/auth.es6.js';
import AccountService from 'services/account.es6.js';
import getPlan from 'components/getPlan.vue';
import Meter from 'components/Meter.vue';


const axios = require('axios');

export default {
  name: 'Settings',
  data() {
    return {
      user: {},
      message: false,
      success: false,
      error: false,
      modal: {
        show: false,
      },
      userAccount: '',
      modalerror: {
        show: false,
      },
      updatedAccount: '',
      updatedProfile: '',
      subscription: {
        plan_display_name: '',
      },
      newAvatar: '',
      password_repeat: '',
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.user.profile = JSON.parse(localStorage.getItem('profile'));
    this.user.account = JSON.parse(localStorage.getItem('account'));
    if (!this.user.profile || !this.user.account) {
      this.$router.push('/');
    }
  },
  mounted() {
    this.getUserAccount();
    this.updatedAccount = _.pick(this.user.account, 'email'),
    this.updatedProfile = _.pick(this.user.profile, 'realname', 'description', 'url', 'marketing_consent', 'tracking_consent');
  },
  methods: {
    processAvatar(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.newAvatar = e.target.result;
        this.updatedProfile.avatar = image;
      };
    },
    updateUserSuccess(data) {
      this.message = true;
      this.success = true;
      ProfileService.version++;
      this.modal.show = false;
      AuthService.updateUser('profile', data[0]);
      AuthService.updateUser('account', data[1].data);
    },

    UpdateUserError(error) {
      const key = _.keys(error)[0];
      const msg = error[key][0] || 'There is an error with your form';
      this.message = true;
      this.error = msg;
    },

    readyForm(profile) {
      if (profile.url) {
        profile.url = UtilitiesService.prefixHttp(profile.url);
      }
      const profileForm = UtilitiesService.createFormData(profile);
      return profileForm;
    },

    updateUserInvoke() {
      const self = this;
      const profileForm = this.readyForm(self.updatedProfile);
      axios.all([
        ProfileService.update(profileForm),
        AccountService.update(self.updatedAccount),
      ])
        .then(function (value) {
          self.updateUserSuccess(value);
        })
        .catch(function () {
          self.UpdateUserError();
        });
    },
    convertToGb(bytes) {
      if (bytes === null) {
        return 'Unlimited';
      }
      if (bytes === 0) { return '0'; }
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
    },

    isOverLimit(val1, val2) {
      if (val2 === null) {
        return false;
      } else {
        return val1 >= val2;
      }
    },

    removeOverlay() {
      this.modal.show = false;
      this.modalerror.show = false;
      $('body').unbind('touchmove');
      $('body').removeClass('disable-scrolling');
    },

    getUserAccount() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
      const self = this;
      return AccountService.get().then(function (data) {
        self.user.account = data.data;
        self.subscription = self.user.account.subscription;
      });
    },

    openManageSub() {
      $('body').bind('touchmove', function (e) {
        e.preventDefault();
      });
      document.body.className += ' ' + 'disable-scrolling';
      if (!this.subscription.merchant_manage_url) {
        this.modalerror.show = true;
      } else {
        const manageUrl = new URL(this.subscription.merchant_manage_url);
        if (manageUrl.host.endsWith('flixel.com') && manageUrl.pathname === '/settings/flixel-cloud/manage/') {
          this.cancelUrl = manageUrl.searchParams.get('cancel');
          this.updateUrl = manageUrl.searchParams.get('update');
          this.modal.show = true;
        } else {
          window.open(this.subscription.merchant_manage_url, '_blank');
        }
      }
    },
    checkPlan(plan) {
      return plan === this.subscription.plan;
    },
  },
  filters: {
    date: function (date) {
      return moment.utc(date).format('DD MMMM YYYY');
    },
    number: function (number) {
      if (number === null) {
        return 0;
      } else {
        return number;
      }
    },
  },
  components: {
    'getPlan': getPlan,
    'Meter': Meter,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Settings.vue